<p-popover #op appendTo="body" styleClass="quick-access-panel" (onShow)="panelToggle.emit(true)" (onHide)="panelToggle.emit(false)">
  <div class="quick-access-grid">
    @for (item of items; track item) {
      <a class="quick-access-item" [href]="item.url" target="_blank">
        <div [style.background-image]="'url(' + item.icon + ')'" class="quick-access-icon"></div>
        <span>{{ item.name | translate }}</span>
      </a>
    }
  </div>
</p-popover>
